/* The value card in full.
 *
 * The Value screen keeps the figure, the move, the line and the windows, which
 * is what opening the app is for. Everything that explains or compares the line
 * — money paid in, the indices beside it, gains and return, results, the period
 * the move is measured over — is here, one tap from the bars in the header, and
 * opens on the window that was on screen there. */

import { HideToggle } from '../components/HideToggle';
import { ValuePanel } from '../components/ValuePanel';
import { useDisplay } from '../state/display';
import type { RangeKey } from '../state/series';
import type { Nav } from '../App';

export function ValueDetails({ nav, range, from, to }: {
  nav: Nav;
  range?: RangeKey;
  from?: string;
  to?: string;
}) {
  const { currency, toDisplay } = useDisplay();

  return (
    <div className="screen">
      <div className="screen-head">
        <button className="back" onClick={nav.back} aria-label="Back">‹</button>
        <h1>Value in detail</h1>
        <span style={{ marginLeft: 'auto' }} />
        <HideToggle />
      </div>

      <ValuePanel
        toDisplay={toDisplay}
        currency={currency}
        {...(range ? { initialRange: range } : {})}
        {...(from && to ? { initialCustom: { from, to } } : {})}
        onOpenResults={() => nav.go({ name: 'results' })}
        onOpenDeposits={() => nav.go({ name: 'settings', group: 'money' })}
      />
    </div>
  );
}
